import { render } from "./TalentTable.vue?vue&type=template&id=658c936e&scoped=true"
import script from "./TalentTable.vue?vue&type=script&lang=js"
export * from "./TalentTable.vue?vue&type=script&lang=js"

import "./TalentTable.vue?vue&type=style&index=0&id=658c936e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658c936e"]])

export default __exports__